module.exports = __webpack_public_path__ + "static/media/cmr_7.83cb5d42.jpg";